import React, { useState, useEffect } from "react";
import VideoModal from "./VideoModal";

const VideoModalContainer = ({ doctorId }) => {
  if (!doctorId) return <></>;
  return <VideoModal doctorId={doctorId} />;
};

export default VideoModalContainer;
